import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { gsap, gsapScrollTo, ScrollTrigger } from '../layout';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

gsap.registerPlugin(ScrollToPlugin)


function homeHeroSwiper() {
    const swiper = new Swiper('.hero__swiper', {
        modules: [Autoplay, Navigation, Pagination],
        speed: 1200,
        pagination: {
            el: '.hero__swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        autoplay: {
            delay: 6000,
        },
        loop: true,
    })

    gsap.fromTo('.hero__image', {
        scale: 1,
    }, {
        duration: 30,
        scale: 1.2,
    })

    swiper.on('slideChange', () => {
        gsap.fromTo('.hero__image', {
            scale: 1,
        }, {
            duration: 30,
            scale: 1.2,
        })
    })
}

function businessSectorSwiper() {
    // get space between element and window
    const containerSize = document.querySelector('.business .container').offsetWidth
    const windowSize = window.innerWidth
    const businessSwiper = document.querySelector('.business__swiper')
    const containerSpacing = (windowSize - containerSize) / 2

    if (window.innerWidth >= 992) {
        businessSwiper.style.marginLeft = containerSpacing + 'px'
    }

    const swiper = new Swiper('.business__swiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 10,
        slidesOffsetBefore: containerSpacing + 12,
        slidesOffsetAfter: containerSpacing + 12,
        pagination: {
            el: '.business__swiper-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.business__swiper-button-next',
            prevEl: '.business__swiper-button-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 20,
                slidesPerView: 2.5,
            },
            992: {
                slidesOffsetBefore: 0,
                spaceBetween: 30,
                slidesPerView: 3.5,
            },
        }
    })
}

function snapToBusiness() {

    ScrollTrigger.create({
        trigger: '.business',
        markers: false,
        start: 'top+=15px bottom',
        end: 'top-=15px top',
        onEnter: () => {
            // console.log('start')
            //     gsap.to(window, {
            //         duration: .3,
            //         scrollTo: elPos
            //     })
            window.onscroll = () => {
                // console.log('start')
                if (ScrollTrigger.isTouch !== 1) {
                    const elPos = document.querySelector('.business').offsetTop
                    window.scrollTo({
                        top: elPos,
                        left: 0,
                    });
                }
            }
        },
        onLeave: () => {
            window.onscroll = () => {
                // console.log('end')
            }
        },
        // toggleActions: 'play none none restart',
    })
}

window.addEventListener('DOMContentLoaded', () => {
    homeHeroSwiper()
    businessSectorSwiper()
    snapToBusiness()
})